import React from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { boxStyles } from '../constants/styles';
import { PageHeaderLoader } from './common/page-header-loader';
import { SkeletonLoaders } from './common/skeleton-loaders';

const EmailHeaderLoader = () => (
  <SkeletonLoaders
    loaders={[{ width: '20%' }, { width: '45%' }, { width: '20%', height: '100px' }]}
    testId="email-header-loader"
  />
);

const EmailFooterLoader = () => (
  <Box testId="email-footer-loader">
    <SkeletonLoaders loaders={[{ width: '45%' }]} />
    <SkeletonLoaders
      loaders={[...Array(3)].map(() => ({ width: '30%', circle: true, height: '25px' }))}
      useSingleWrapper
    />
    <SkeletonLoaders loaders={[{ width: '70%' }, { width: '50%' }, { width: '20%' }]} />
  </Box>
);

const EmailMainContentLoader = () => (
  <SkeletonLoaders
    loaders={[
      { width: '10%', isCenterAligned: false },
      { width: '100%' },
      { width: '100%', height: '50px' },
      { width: '100%', height: '50px' },
      { width: '100%', height: '50px' },
      { width: '100%', height: '50px' },
      { width: '10%', isCenterAligned: false },
      { width: '15%', isCenterAligned: false },
    ]}
    testId="email-main-content-loader"
  />
);

const EmailDetailsLoader = () => {
  return (
    <Box testId="email-details-loader">
      {[...Array(5)].flatMap(() => (
        <SkeletonLoaders
          loaders={[{ width: '5%', marginRight: '9.5rem' }, { width: '20%' }]}
          useSingleWrapper
          isLoadersCenterAligned={false}
        />
      ))}
    </Box>
  );
};

export const EmailDetailsPageLoader = () => {
  return (
    <div className="pl-8">
      <PageHeaderLoader hideActions />
      <EmailDetailsLoader />
      <br />
      <Flex xcss={boxStyles} justifyContent="center">
        <Box xcss={xcss({ width: '60%', padding: 'space.800' })}>
          <EmailHeaderLoader />
          <EmailMainContentLoader />
          <EmailFooterLoader />
        </Box>
      </Flex>
    </div>
  );
};
